import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { convertPdftoBlobUrl } from 'apps/studio/lib/utils/fileUploads'
import { addPdf } from 'apps/studio/store/actions/sharedActions'
import { appSettingsActions } from 'apps/formsCreationKit/store/reducers/settings/appSettings'
import { plgDemoSelector } from 'apps/studio/store/selectors/studioSettings'
import { stagePlgPdf } from 'apps/studio/lib/builderRequests'
const { updateFlashMessage } = appSettingsActions

export const PDF_FILE_INPUT_ID = 'pdf-loader--input'

export const PdfLoaderInput = ({
  onFileSelect,
  inputId = PDF_FILE_INPUT_ID,
}) => {
  return (
    <input
      className="studio--pdf-loader--input"
      id={inputId}
      aria-label="Upload PDF"
      type="file"
      accept="application/pdf"
      onChange={e => {
        if (e.target.files.length) {
          onFileSelect(e.target.files[0])
        }
        e.target.value = ''
      }}
    />
  )
}

export const PDFLoader = ({
  children,
  inputId = PDF_FILE_INPUT_ID,
  onClick,
  className = '',
  onFile,
  onError,
}) => {
  const dropZoneRef = useRef()
  const dispatch = useDispatch()
  const plgDemo = useSelector(plgDemoSelector)
  const [hasDrop, setHasDrop] = useState(false)
  const handleFileSelect = file => {
    const fileName = file.name

    convertPdftoBlobUrl(file)
      .then(blobFileUrl => {
        // if custom action is provided, call it
        if (onFile) {
          onFile(blobFileUrl, fileName, dispatch)
        } else {
          // otherwise, dispatch the default action
          dispatch(addPdf({ pdf_path: blobFileUrl, fileName }))
        }
        if (plgDemo) {
          stagePlgPdf(file).catch(err => {
            const message =
              err?.response?.data?.error || 'Could not save PDF for your account'
            dispatch(updateFlashMessage({ message, type: 'error' }))
          })
        }
      })
      .catch(error => {
        const { message } = error
        if (onError) {
          // custom error handler
          onError(message)
        } else {
          // default error handling
          dispatch(
            updateFlashMessage({
              message,
              type: 'error',
            })
          )
        }
      })
  }

  // provide file from drop
  const handleDrop = async event => {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (file) {
      setHasDrop(false)
      handleFileSelect(file)
    }
  }

  const handleDragOver = event => {
    event.preventDefault()
    setHasDrop(true)
  }

  const labelClasses = `${className} studio--pdf-loader ${
    hasDrop ? 'has-dragover' : ''
  }`

  return (
    <>
      <label
        className={labelClasses}
        htmlFor={inputId}
        ref={dropZoneRef}
        onClick={onClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={() => setHasDrop(false)}
        aria-controls={inputId}
      >
        {children}
      </label>
      <PdfLoaderInput inputId={inputId} onFileSelect={handleFileSelect} />
    </>
  )
}
